module.exports = __webpack_public_path__ + "static/media/loginicon.53220c51.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/loginicon.png
// module id = 172
// module chunks = 0